import { FunctionComponent, ReactElement } from "react";

import { InputAdornment, TextField } from "@mui/material";

import { Info } from "@mui/icons-material";

import { FormikErrors, FormikTouched } from "formik";

import { Paper } from "../../../components/common";

import {
    FreebieRuleSection,
    IFreebieRuleForm,
    Row,
    SectionTitle,
    StyledTooltip,
    TextFieldContainer,
} from "./common";

export interface IDiscountCodeSectionProps {
    values: IFreebieRuleForm;
    touched: FormikTouched<IFreebieRuleForm>;
    errors: FormikErrors<IFreebieRuleForm>;
    onChange: (e: React.ChangeEvent<any>) => void;
    onBlur: {
        (e: React.FocusEvent<any, Element>): void;
        <T = any>(fieldOrEvent: T): T extends string ? (e: any) => void : void;
    };
}

export const DiscountCodeSection: FunctionComponent<
    IDiscountCodeSectionProps
> = (props: IDiscountCodeSectionProps): ReactElement => {
    const { values, errors, touched, onChange, onBlur } = props;
    return (
        <Paper>
            <FreebieRuleSection>
                <SectionTitle>Discount code</SectionTitle>
                <Row>
                    <TextFieldContainer>
                        <TextField
                            fullWidth={true}
                            required={true}
                            name="discountCode"
                            value={values.discountCode}
                            onChange={onChange}
                            label="Discount code"
                            size="small"
                            variant="outlined"
                            onBlur={onBlur}
                            InputProps={{
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <StyledTooltip
                                            enterTouchDelay={0}
                                            placement="top"
                                            title="The freebie is granted when this discount code is applied to the cart."
                                        >
                                            <Info
                                                htmlColor="#626262"
                                                fontSize="small"
                                            />
                                        </StyledTooltip>
                                    </InputAdornment>
                                ),
                            }}
                            error={
                                Boolean(errors.discountCode) &&
                                touched.discountCode
                            }
                            helperText={
                                touched.discountCode && errors.discountCode
                            }
                        />
                    </TextFieldContainer>
                    <TextFieldContainer />
                </Row>
            </FreebieRuleSection>
        </Paper>
    );
};
